import Title from 'antd/lib/typography/Title';
import React from 'react';
import MaterialTable from '../../../containers/MaterialTable/MaterialTable';

const Leaders = ({data, type}) => {
    const columns = [
        {
            title: 'Company Name',
            dataIndex: 'name',
            key: 'name',
            render: text => <strong>{text}</strong>,
        },
        {
            title: 'Company Ticker',
            dataIndex: 'ticker',
            key: 'ticker',
        },
        {
            title: 'Previos Close',
            dataIndex: 'prevclose',
            key: 'prevclose',
        },
        {
            title: 'Change',
            key: 'change',
            dataIndex: 'change',
            render: change => <span style={{color: `${change > 0 ? "green" : "red"}`}}> <strong>{change}</strong> </span>
        },
        {
            title: 'Change %',
            key: 'changepercentage',
            dataIndex: "changepercentage",
            render: changepercent => <span style={{color: `${changepercent > 0 ? "green" : "red"}`}}> <strong>{changepercent} %</strong> </span>
        }
    ];
    return (
        <div>
            <Title level={3} className="text-center pb-4" style={{color: "rgba(18, 15, 62, 0.91)"}}>
                {
                    type === "leaders" ? 
                    "Leading stocks of the day" : 
                    "Losing stocks of the day"
                }
            </Title>
            <MaterialTable data={data} columns={columns}/>
        </div>
    )
}

export default Leaders
